/* Import dependencies */
import '../css/main.css'
import { init_status_observer } from './intersection-observer';

(($,undefined) => {

    init_status_observer();
  
        $(document).ready(function(){

        // Toggle navigation
        $('#navbar-toggle').on('click', function () {
          console.log('click');
          if ( !$(this).hasClass('navbar-toggle-active') ) {
            $(this).addClass('navbar-toggle-active');
            $('.menu-responsive').fadeIn();
          } else {
            $(this).removeClass('navbar-toggle-active');
            $('.menu-responsive').fadeOut();
          } // $('#navbar-toggle').on('click'a
        });

        menuShow();

        $('.schedule-btn').on('click', function () {
          $('.schedule').fadeIn();
        });

        $('.close-sch').on('click', function () {
          $('.schedule').fadeOut();
        });

        $('.bio-button').click(function() {
          var idi = $(this).attr('data-type');
              $('.bio').hide();
              $('.bio[data-type="'+idi+'"]').fadeIn();
          });

        $('.close-sch').on('click', function () {
          $('.bio').fadeOut();
        });

        function isVisible($el) {
          var winTop = $(window).scrollTop();
          var winBottom = winTop + $(window).height();
          var elTop = $el.offset().top;
          var elBottom = elTop + $el.height() / 2;
          return ((elBottom + 90 <= winBottom) && (elTop + 90 >= winTop));
        }

      var lastScrollTop = 0;

      $(window).scroll(function (event) {
        
        $('.fdi').each(function () {
          if (isVisible($(this))) {
            $(this).removeClass('fdi');
            $(this).addClass('animate__fadeIn').stop().css('opacity','1');	
          }
        });

        $('.fiu').each(function () {
          if (isVisible($(this))) {
            $(this).removeClass('fiu');
            $(this).addClass('animate__fadeInUp').stop().css('opacity','1');
          }
        });

        $('.fir').each(function () {
          if (isVisible($(this))) {
            $(this).removeClass('fir');
            $(this).addClass('animate__fadeInRight').stop().css('opacity','1');
          }
        });

        $('.fil').each(function () {
          if (isVisible($(this))) {
            $(this).removeClass('fil');
            $(this).addClass('animate__fadeInLeft').stop().css('opacity','1');
          }
        });

        $('.down').each(function () {
          if (isVisible($(this))) {
             $(this).fadeOut();
          }
        });

        // $('.step').each(function () {
          // if (isVisible($(this))) {
            //  $(this).addClass('hidden').setTimeout(addClass, 11000);;
          // }
        // });

        var st = $(this).scrollTop();
        if (st > lastScrollTop) {
            //console.log('up');
          } else {
            //console.log('down');
          }
          lastScrollTop = st;
        });


        $(window).resize(function(e) {
          menuShow();
        });
          
          menuShow();
        });	
            
      $(window).load(function() {
        menuShow();
      });

      $(window).resize(function(e) {
        menuShow();
      });

      function menuShow() {
        if($(window).outerWidth() > 760)
        { $('#menu').show(); }
        else {
          $('#navbar-toggle').removeClass('navbar-toggle-active');
          $('#menu').hide();
        } 
      }
})(jQuery)